/**
 * @doc Editor
 */
export enum PremiumIntent {
  Neutral = 'NEUTRAL',
  Free = 'FREE',
  Paid = 'PAID',
}

export type PremiumIntentStrings = 'NEUTRAL' | 'FREE' | 'PAID'
export type SiteUpgrade = 'SITE_UPGRADE'
export type AppUpgrade = 'APP_UPGRADE'
export type UpgradeTypes = AppUpgrade | SiteUpgrade

export type PremiumOptions = {
  premiumIntent?: PremiumIntentStrings
  referrer?: string
  upgradeType: UpgradeTypes
  appDefinitionId: string
}
